"use strict";function checkPassword$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.checkPassword$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.user.checkPassword";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.5.8"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.5.8"},_a)),exports.checkPassword$=checkPassword$,exports.default=checkPassword$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/user/checkPassword.js
// module id = 998
// module chunks = 106